// extracted by mini-css-extract-plugin
export default {"container":"CustomNumber_container__AQR-N","decrease":"CustomNumber_decrease__M+Q-d","increase":"CustomNumber_increase__zE6tx","input__size":"CustomNumber_input__size__y2nBT"};